<template>
  <el-row class="links__row home__section">
    <el-col
      :xs="{ span: 18, offset: 3 }"
      :sm="{ span: 14, offset: 5 }"
      :md="{ span: 14, offset: 5 }"
      :lg="{ span: 14, offset: 5 }"
      :xl="{ span: 12, offset: 6 }"
    >
      <h4 class="links__heading">關注我們</h4>

      <el-row :gutter="30">
        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="links__link-wrapper">
            <a :href="socialMedia.facebook.url" target="_blank" class="links__link">
              <span class="links__icon-wrapper">
                <img src="@/assets/images/facebook.png" :alt="socialMedia.facebook.name">
              </span>
              <span class="links__title">{{ socialMedia.facebook.name }}</span>
            </a>
          </div>
        </el-col>

        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="links__link-wrapper">
            <a :href="socialMedia.youtube.url" target="_blank" class="links__link">
              <span class="links__icon-wrapper">
                <img src="@/assets/images/youtube.png" :alt="socialMedia.youtube.name" class="links__img-youtube">
              </span>
              <span class="links__title">{{ socialMedia.youtube.name }}</span>
            </a>
          </div>
        </el-col>

        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="links__link-wrapper">
            <a :href="socialMedia.line.url" target="_blank" class="links__link">
              <span class="links__icon-wrapper">
                <img src="@/assets/images/line.png" :alt="socialMedia.line.name">
              </span>
              <span class="links__title">{{ socialMedia.line.name }}</span>
            </a>
          </div>
        </el-col>

        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="links__link-wrapper">
            <a :href="socialMedia.instagram.url" target="_blank" class="links__link">
              <span class="links__icon-wrapper">
                <img src="@/assets/images/instagram.png" :alt="socialMedia.instagram.name">
              </span>
              <span class="links__title">{{ socialMedia.instagram.name }}</span>
            </a>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data () {
    return {
      socialMedia: {
        facebook: {
          name: 'Facebook',
          url: 'https://www.facebook.com/StudioClassroom/'
        },
        youtube: {
          name: 'YouTube',
          url: 'https://www.youtube.com/channel/UCqQ16nrVsO5Np9L24EnNstg'
        },
        line: {
          name: 'LINE',
          url: 'https://line.me/ti/p/%40linedailyeng'
        },
        instagram: {
          name: 'Instagram',
          url: 'https://www.instagram.com/sc.friends/'
        }
      }
    }
  }
}
</script>
